<template>
    <div id="app-root" class="app-root">
        <main class="app-main">
            <router-view></router-view>
        </main>
        <AppFooter v-if="mostrarFooter" />
    </div>
</template>

<script>
import AppFooter from '@/components/layout/AppFooter.vue';
import '@popperjs/core';
import { Modal } from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { pushModalGuard, popModalGuard } from '@/utils/modalBackGuard';
export default {
    name: 'App',
    components: {
        AppFooter,

    },
    computed: {
        mostrarFooter() {
            return !this.$route.matched.some((record) => record.meta && record.meta.requiresAuth);
        },
    },
    methods: {
        // checkAuthentication() {
        //   const isAuthenticated = !!localStorage.getItem("token");/* Agrega aquí tu lógica para verificar si el usuario está autenticado */
        //   if (!isAuthenticated) {
        //     this.$router.push("/login");
        //   }
        // },
        /**
         * Registro global (una sola vez para toda la app) que engancha CUALQUIER modal
         * de Bootstrap (data-bs-toggle="modal" o `new Modal(...).show()`) con el botón
         * "atrás", sin necesidad de tocar cada componente que abre un modal.
         */
        onBsModalShown(evento) {
            const el = evento.target;
            if (this.bsModalGuards.has(el)) return;
            const guardId = pushModalGuard(() => {
                this.bsModalGuards.delete(el);
                const instancia = Modal.getInstance(el);
                if (instancia) instancia.hide();
            });
            this.bsModalGuards.set(el, guardId);
        },
        onBsModalHidden(evento) {
            const el = evento.target;
            const guardId = this.bsModalGuards.get(el);
            if (guardId != null) {
                this.bsModalGuards.delete(el);
                popModalGuard(guardId);
            }
        },
    },
    mounted() {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        this.bsModalGuards = new WeakMap();
        document.addEventListener('show.bs.modal', this.onBsModalShown);
        document.addEventListener('hidden.bs.modal', this.onBsModalHidden);
    },
    beforeUnmount() {
        document.removeEventListener('show.bs.modal', this.onBsModalShown);
        document.removeEventListener('hidden.bs.modal', this.onBsModalHidden);
    },
}
</script>

<style>
html {
    overflow-y: auto;
}

body {
    background-color: var(--po-bg, #f0f4f8);
    padding: 0 !important;
}

.app-root {
    min-height: 100dvh;
    min-height: 100svh;
    display: flex;
    flex-direction: column;
}

.app-main {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding-bottom: env(safe-area-inset-bottom, 0);
}

.app-main > * {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
}

.pl-2 {
    padding-left: 10px;
}

.modalCategoriaContainer {
    position: absolute;
    z-index: 1233;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100svh;
    background-color: rgba(0, 0, 0, 0.8);
}

.modalCategoria {
    padding: 15px;
    margin: auto;
    width: 30vw;
    background-color: white;
    border-radius: 10px;
}

.btn-limpiar {
    display: block;
    background: linear-gradient(rgb(255, 255, 255),
            rgb(214, 214, 214)) !important;
    border: none;
    border-radius: 2px;
}

.btn-limpiar:hover {
    background: linear-gradient(rgb(242, 242, 242),
            rgb(201, 201, 201)) !important;
    cursor: pointer;
}

/* .btn-menu / .btn-menu-danger: ver global-ui.css */

.navbar-toggler {
    outline: 0 !important;
    border: none !important;
    color: transparent;
    margin-left: 10px;
    padding: 3px;
}

.navbar-toggler:focus {
    outline: 0 !important;
    background: lightgray !important;
}


.btn-agregar {
    background: linear-gradient(rgb(255, 251, 234), rgb(255, 240, 155)) !important;
    box-shadow: 0.2px 0.2px 2px white;
    border: none;
    border-radius: 1px;
}

.btn-agregar:hover {
    background: linear-gradient(rgb(253, 247, 217), rgb(255, 236, 128)) !important;
}

.barra-busqueda {
    border: none;
    box-shadow: 0.2px 0.2px 2px !important;
    border-radius: 1px !important;
}

.texto-carga {
    font-style: italic;
    margin: 20px;
    color: grey;
}

.logo-carga {
    margin-top: -10vh;
}

.logo-img {
    animation: l2 2s infinite;
}

.form-control {
    border-radius: 4px !important;
}

/* Solo búsquedas con botón de limpiar a la derecha */
.barra-busqueda.form-control,
.barra-busqueda .form-control {
    padding-right: 2.5rem;
}

.nav-logo {
    border-radius: 100%;
    width: 40px;
    height: 40px;
    margin-right: 10px;
}

.form-control:focus {
    box-shadow: none;
}

.pantalla-carga {
    z-index: 20;
    position: fixed;
    top: 0;
    left: 0;
    width: 100svw;
    height: 100svh;
    background-color: white;
    align-content: center;
}

.pantalla-carga:hover {
    cursor: wait;
}

@keyframes l2 {
    to {
        transform: rotate(1turn)
    }
}

@media screen and (max-width: 992px) {

    .modalCategoria {
        width: 90vw;
    }

}
</style>
